"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-tabs/lib/RefMixin.js
// module id = 759
// module chunks = 0 1